export var AvatarTypeTokens;
(function (AvatarTypeTokens) {
    AvatarTypeTokens["SINGLE"] = "SINGLE";
    AvatarTypeTokens["MULTIPLE"] = "MULTIPLE";
})(AvatarTypeTokens || (AvatarTypeTokens = {}));
export var ActiveStateTokens;
(function (ActiveStateTokens) {
    ActiveStateTokens["ACTIVE"] = "ACTIVE";
    ActiveStateTokens["INACTIVE"] = "INACTIVE";
})(ActiveStateTokens || (ActiveStateTokens = {}));
export var AvatarSizeTokens;
(function (AvatarSizeTokens) {
    AvatarSizeTokens["XS"] = "XS";
    AvatarSizeTokens["SM"] = "SM";
    AvatarSizeTokens["MD"] = "MD";
    AvatarSizeTokens["LG"] = "LG";
    AvatarSizeTokens["XL"] = "XL";
    AvatarSizeTokens["XXL"] = "XXL";
    AvatarSizeTokens["XXXL"] = "XXXL";
})(AvatarSizeTokens || (AvatarSizeTokens = {}));
